export default class FixSocialMediaButtons {
	static SOCIAL_MEDIA_BUTTONS_SELECTOR	= '.et_pb_social_media_follow a';
	static ARIA_HIDDEN_ATTRIBUTE = 'aria-hidden';

	start() {
		if ($('.ENABLE_FIX_SOCIAL_MEDIA_BUTTONS').length === 0) {
			return;
		}
		this.fixSocialMediaButtons();
	}

	fixSocialMediaButtons() {
		$(window).on('load', () => {
			const socialButtons = $(FixSocialMediaButtons.SOCIAL_MEDIA_BUTTONS_SELECTOR);
			if (socialButtons.length) {
				let title = '';
				socialButtons.each((i, button) => {
					title = $(button).attr('title');
					$(button).attr('target', '_blank').removeAttr('title').removeAttr('role')
						.find('span')
						.removeAttr(FixSocialMediaButtons.ARIA_HIDDEN_ATTRIBUTE)
						.html(`${title}, opens in a new window`);
				});
			}
		});
	}
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/footer/controllers/fix-social-media-buttons.js